import React from 'react';
import { motion } from 'framer-motion';
import { ShieldAlert, Search, FileWarning, UserX, Brain } from 'lucide-react';
const ALERTS = [{
  id: 1,
  type: 'document',
  severity: 'high',
  message: 'Potential forged bank statement detected',
  user: 'John Doe',
  confidence: 98,
  time: '2 mins ago'
}, {
  id: 2,
  type: 'identity',
  severity: 'medium',
  message: 'Face match mismatch with ID document',
  user: 'Sarah Smith',
  confidence: 85,
  time: '15 mins ago'
}, {
  id: 3,
  type: 'behavior',
  severity: 'low',
  message: 'Unusual login location detected',
  user: 'Mike Johnson',
  confidence: 65,
  time: '1 hour ago'
}];
export function FraudDetection() {
  return <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden transition-colors" data-id="element-338">
      <div className="p-4 sm:p-6 border-b border-gray-100 dark:border-gray-700 bg-gradient-to-r from-red-50 to-orange-50 dark:from-red-900/20 dark:to-orange-900/20" data-id="element-339">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-340">
          <div className="flex items-center gap-3 min-w-0" data-id="element-341">
            <div className="p-2 bg-white dark:bg-gray-800 rounded-lg shadow-sm flex-shrink-0" data-id="element-342">
              <Brain className="w-5 h-5 text-red-600 dark:text-red-400" data-id="element-343" />
            </div>
            <div className="min-w-0" data-id="element-344">
              <h3 className="font-bold text-gray-900 dark:text-white truncate" data-id="element-345">
                AI Fraud Monitor
              </h3>
              <p className="text-xs text-red-600 dark:text-red-400 font-medium" data-id="element-346">
                3 High Risk Alerts
              </p>
            </div>
          </div>
          <span className="flex items-center px-3 py-1 bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-300 rounded-full text-xs font-bold shadow-sm whitespace-nowrap flex-shrink-0" data-id="element-347">
            <div className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse flex-shrink-0" data-id="element-348"></div>
            Monitoring Active
          </span>
        </div>
      </div>

      <div className="divide-y divide-gray-100 dark:divide-gray-700" data-id="element-349">
        {ALERTS.map(alert => <div key={alert.id} className="p-4 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors" data-id="element-350">
            <div className="flex flex-col sm:flex-row items-start justify-between gap-3" data-id="element-351">
              <div className="flex items-start gap-3 min-w-0 flex-1" data-id="element-352">
                <div className={`p-2 rounded-lg flex-shrink-0 ${alert.severity === 'high' ? 'bg-red-100 text-red-600 dark:bg-red-900/30 dark:text-red-400' : alert.severity === 'medium' ? 'bg-orange-100 text-orange-600 dark:bg-orange-900/30 dark:text-orange-400' : 'bg-yellow-100 text-yellow-600 dark:bg-yellow-900/30 dark:text-yellow-400'}`} data-id="element-353">
                  {alert.type === 'document' ? <FileWarning className="w-4 h-4" data-id="element-354" /> : alert.type === 'identity' ? <UserX className="w-4 h-4" data-id="element-355" /> : <ShieldAlert className="w-4 h-4" data-id="element-356" />}
                </div>
                <div className="min-w-0 flex-1" data-id="element-357">
                  <p className="text-sm font-bold text-gray-900 dark:text-white break-words" data-id="element-358">
                    {alert.message}
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400 truncate" data-id="element-359">
                    User: {alert.user} • {alert.time}
                  </p>
                </div>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-360">
                <span className={`inline-block px-2 py-0.5 rounded text-[10px] font-bold uppercase mb-1 ${alert.severity === 'high' ? 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300' : alert.severity === 'medium' ? 'bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300' : 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300'}`} data-id="element-361">
                  {alert.severity}
                </span>
                <p className="text-xs text-gray-400 dark:text-gray-500" data-id="element-362">
                  {alert.confidence}% Confidence
                </p>
              </div>
            </div>
            <div className="mt-3 flex gap-2" data-id="element-363">
              <button className="flex-1 py-1.5 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded text-xs font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors" data-id="element-364">
                Investigate
              </button>
              <button className="flex-1 py-1.5 bg-red-50 dark:bg-red-900/20 border border-red-100 dark:border-red-800 rounded text-xs font-medium text-red-700 dark:text-red-400 hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors" data-id="element-365">
                Block User
              </button>
            </div>
          </div>)}
      </div>

      <div className="p-4 bg-gray-50 dark:bg-gray-700/50 border-t border-gray-100 dark:border-gray-700 text-center" data-id="element-366">
        <button className="text-sm font-medium text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white flex items-center justify-center mx-auto transition-colors" data-id="element-367">
          View All Alerts <Search className="w-4 h-4 ml-1 flex-shrink-0" data-id="element-368" />
        </button>
      </div>
    </div>;
}